import { action, makeObservable, observable } from 'mobx';
import client from '~/services/client';
import logger from '~/services/logger';

export class MenuGroupImprovementStore {
  constructor() {
    makeObservable(this);
  }

  @observable isLoading: boolean = false;
  @observable isRequestWasSended: boolean = false;
  @observable menuGroupImprovementList: any[] | undefined = undefined;

  @action getMenuGroupImprovementList = async () => {
    try {
      this.isLoading = true;
      const pagination = await client.get(`/v4/menu/health-check`);
      this.isRequestWasSended = true;
      this.menuGroupImprovementList = pagination;
    } catch (error) {
      logger.error({ error, place: 'MenuGroupImprovementStore getMenuGroupImprovementList' });
    } finally {
      this.isLoading = false;
    }
  };

  @action resetMenuGroupImprovementList = () => {
    this.menuGroupImprovementList = undefined;
    this.isRequestWasSended = false;
  };
}

const menuGroupImprovementStore = new MenuGroupImprovementStore();

export default menuGroupImprovementStore;
